import React, { useState, useEffect } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { googleMapsLoaderOptions } from "../../../config/googleMaps";

interface MapComponentProps {
  selectedLocation: any;
  defaultCenter: { lat: number; lng: number };
  mapContainerStyle: React.CSSProperties;
  getCustomIcon: (name: string) => string;
}

const MapComponent: React.FC<MapComponentProps> = ({
  selectedLocation,
  defaultCenter,
  mapContainerStyle,
  getCustomIcon,
}) => {
  const [googleLoaded, setGoogleLoaded] = useState(false);
  const [, setIcons] = useState<{
    [color: string]: google.maps.Icon | null;
  }>({});
  const pinColors = ["red", "blue", "green", "yellow", "purple", "orange"];

  const { isLoaded } = useJsApiLoader(googleMapsLoaderOptions);

  useEffect(() => {
    if (!isLoaded) return;
    const iconMap: { [color: string]: google.maps.Icon | null } = {};
    pinColors.forEach((color) => {
      iconMap[color] = {
        url: `http://maps.google.com/mapfiles/ms/icons/${color}-dot.png`,
        scaledSize: new google.maps.Size(32, 32),
      };
    });
    setIcons(iconMap);
    setGoogleLoaded(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded]);
  //console.log("datanya", selectedLocation);
  if (!isLoaded) {
    return <div style={mapContainerStyle} />;
  }

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      zoom={selectedLocation ? 12 : 8}
      center={
        selectedLocation
          ? {
              lat: selectedLocation.latitude,
              lng: selectedLocation.longitude,
            }
          : defaultCenter
      }
    >
      {selectedLocation && googleLoaded && (
        <Marker
          key={selectedLocation.id}
          position={{
            lat: selectedLocation.latitude,
            lng: selectedLocation.longitude,
          }}
          icon={{
            url: getCustomIcon(selectedLocation.username),
            scaledSize: new google.maps.Size(40, 40),
          }}
        />
      )}
    </GoogleMap>
  );
};

export default MapComponent;
